import React from "react";
import { ArrowLeftIcon } from "../icons";

// The focused creation header, shared by every screen of both Create League
// flows (client Rev 1).
//
// What the client asked for, exactly:
//   • one back arrow in the left corner of the header
//   • the flow title ("Create Public League" / "Create Private League") centred
//   • nothing else — no QUSHi logo, no three-dot menu, no "League Detail" label
//
// It is fixed, so the form scrolls underneath it; the step indicator below is
// ordinary page content and scrolls away normally (the client's note: the
// stepper "must sit below the header on initial load and scroll normally with
// the page. It should never overlap the header or stick.").
//
// HEADER_HEIGHT is exported because two other things are measured off it: the
// top padding of the scrolling content, and how far the keyboard-aware scroll
// has to keep a focused field clear of the header (see wizardScroll.js).
export const HEADER_HEIGHT = 64;

// `md:left-64` clears the desktop sidebar, the same 15rem offset the rest of
// /contest uses (`md:ml-60`).
// `rightAction` is OPTIONAL and nothing renders in its place when it is absent,
// so every Create League screen keeps the header the client specified in Rev 1 —
// "one back arrow... nothing else — no QUSHi logo, no three-dot menu". Only
// League Details passes anything, for the Share control the client asked for on
// that screen.
const WizardHeader = ({ title, onBack, backLabel = "Go back", rightAction = null }) => (
  <header
    className="fixed top-0 left-0 right-0 md:left-64 z-40 bg-white border-b border-[#E5E7EB]"
    style={{ height: HEADER_HEIGHT }}
  >
    <div className="relative h-full max-w-screen-md mx-auto px-4 md:px-8 flex items-center justify-center">
      <button
        type="button"
        onClick={onBack}
        aria-label={backLabel}
        className="absolute left-2 md:left-6 p-2 inline-flex items-center text-[#1A1A1A]"
      >
        <ArrowLeftIcon />
      </button>
      {/* House rule for a screen title: Montserrat bold, teal, Title Case.
          Optional: the payoff screen's header is the back arrow alone, per the
          approved Stitch design. */}
      {title && (
        <h1 className="font-montserrat font-bold text-lg md:text-xl text-pageTitle text-center truncate px-10">
          {title}
        </h1>
      )}
      {rightAction && (
        <div className="absolute right-2 md:right-6 flex items-center">{rightAction}</div>
      )}
    </div>
  </header>
);

export default WizardHeader;
